import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query medioPago {
            TYPES {
              MedioPago {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => result.data.data.TYPES.MedioPago.readAll),
};
